import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
const _excluded = ["portfolioId", "portfolioIds"],
  _excluded2 = ["propertyId"],
  _excluded3 = ["propertyId"],
  _excluded4 = ["propertyId"],
  _excluded5 = ["propertyId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { requestService } from 'src/core/services/api';
import { propertiesRoutes } from './routes';
export class Properties {
  constructor() {
    _defineProperty(this, "routes", propertiesRoutes);
  }
  async getPropertiesDashboard(data, options) {
    const resp = await requestService('aggregate').get(this.routes.propertiesDashboard(data.portfolioId), _objectSpread({
      data
    }, options.cancelToken));
    return resp.data;
  }
  async createNewProperty(data, options) {
    const portfolioId = data.portfolioId,
      portfolioIds = data.portfolioIds,
      rest = _objectWithoutProperties(data, _excluded);
    const requestData = rest;
    if (portfolioId !== null) {
      // eslint-disable-next-line @typescript-eslint/dot-notation
      requestData['portfolioId'] = portfolioId;
    }
    if (portfolioIds !== null) {
      // eslint-disable-next-line @typescript-eslint/dot-notation
      requestData['portfolioIds'] = portfolioIds;
    }
    const resp = await requestService('property').post(this.routes.baseUrl, requestData, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getProperty(data, options) {
    const propertyId = data.propertyId;
    const resp = await requestService('aggregate').get(this.routes.property(propertyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getPropertiesBatch(data, options) {
    const propertyIds = data.propertyIds;
    const resp = await requestService('aggregate').post(this.routes.propertiesList, {
      propertyIds
    }, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async deleteProperty(data, options) {
    const propertyId = data.propertyId;
    const resp = await requestService('property').delete(this.routes.property(propertyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updateProperty(data, options) {
    const propertyId = data.propertyId,
      rest = _objectWithoutProperties(data, _excluded2);
    const resp = await requestService('property').put(this.routes.property(propertyId), rest, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getPropertyFees(data, options) {
    const resp = await requestService('property').get(this.routes.fee(data.propertyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updatePropertyFees(data, options) {
    const propertyId = data.propertyId,
      rest = _objectWithoutProperties(data, _excluded3);
    const resp = await requestService('property').patch(this.routes.fee(propertyId), rest.fees, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updatePropertysContacts(data, options) {
    const propertyId = data.propertyId,
      rest = _objectWithoutProperties(data, _excluded4);
    const resp = await requestService('property').patch(this.routes.propertysContacts(propertyId), rest.data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getPropertyContacts(data, options) {
    const resp = await requestService('property').get(this.routes.propertysContacts(data.propertyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async addPropertyUtilityProvider(data, options) {
    const resp = await requestService('property').post(this.routes.propertiesUtilityProvidersLegacy(data.propertyId) + "/".concat(data.utilityProviderId), {}, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getUnitUtilityProviders(data, options) {
    let getIsBillAutomationEnabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (getIsBillAutomationEnabled) {
      const resp = await requestService('property').get(this.routes.unitUtilityProviders(data.propertyId, data.unitId), _objectSpread({}, options.cancelToken));
      return resp.data;
    } else {
      const resp = await requestService('property').get(this.routes.unitUtilityProvidersLegacy(data.propertyId, data.unitId), _objectSpread({}, options.cancelToken));
      return resp.data;
    }
  }
  async activateProperty(data, options) {
    const resp = await requestService('property').post(this.routes.activate(data.propertyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async deletePropertyUtilityProvider(data, options) {
    const resp = await requestService('property').delete(this.routes.propertiesUtilityProvidersLegacy(data.propertyId) + "/".concat(data.utilityProviderId), {}, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getPropertyUtilityProvidersV3(data, options) {
    let getIsBillAutomationEnabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (getIsBillAutomationEnabled) {
      const resp = await requestService('property').get(this.routes.propertiesUtilityProvidersV3(data.propertyId), _objectSpread({}, options.cancelToken));
      return resp.data;
    } else {
      const resp = await requestService('property').get(this.routes.propertiesUtilityProvidersLegacy(data.propertyId), _objectSpread({}, options.cancelToken));
      return resp.data;
    }
  }

  // Amenities
  async addPropertyCommonAreaAmenity(data, options) {
    const resp = await requestService('property').post(this.routes.propertiesAmenities(data.propertyId), _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getPropertyCommonAreaAmenity(data, options) {
    const resp = await requestService('property').get(this.routes.propertiesAmenities(data.propertyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async patchPropertyCommonAreaAmenities(data, options) {
    const resp = await requestService('property').patch(this.routes.propertiesAmenities(data.propertyId), _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getPropertySetupProgress(data, options) {
    const resp = await requestService('property').get(this.routes.progress(data.propertyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updatePropertySetupProgress(data, options) {
    const propertyId = data.propertyId,
      rest = _objectWithoutProperties(data, _excluded5);
    const resp = await requestService('property').patch(this.routes.progress(propertyId), _objectSpread({}, rest), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getResidentTips(options) {
    const resp = await requestService('property').get('/tips', _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getServerCurrentTime(options) {
    const resp = await requestService('property').get('/time/now', _objectSpread({}, options.cancelToken));
    return resp.data;
  }
}